import { render, staticRenderFns } from "./TeacherLetters.vue?vue&type=template&id=0d2f6e54&"
import script from "./TeacherLetters.vue?vue&type=script&lang=js&"
export * from "./TeacherLetters.vue?vue&type=script&lang=js&"
import style0 from "./TeacherLetters.vue?vue&type=style&index=0&id=0d2f6e54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports